import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from '../Flex';
import { Arrow } from './Arrow';
import { AbsoluteTransformLeft } from './Arrow.styled';
import { arrowPropTypes } from './Arrow';
const TopArrows = ({ arrowPosition, arrowProps }) => {
    const isSide = arrowPosition === 'side';
    const Wrapper = isSide ? AbsoluteTransformLeft : Flex;
    return ['top', 'side'].includes(arrowPosition) ? (React.createElement(Wrapper, { justifyContent: 'flex-end', pb: isSide ? 0 : 2, zIndex: 1, "data-testid": isSide ? 'side-left-arrow' : 'top-arrows' },
        React.createElement(Arrow, Object.assign({ isLeft: true }, arrowProps)),
        isSide ? null : React.createElement(Arrow, Object.assign({}, arrowProps, { ml: 3 })))) : null;
};
TopArrows.propTypes = {
    arrowPosition: PropTypes.oneOf(['top', 'bottom', 'side', 'hide', undefined]),
    arrowProps: PropTypes.shape(arrowPropTypes),
};
export { TopArrows };
//# sourceMappingURL=TopArrows.js.map